import {Injectable} from '@angular/core';
import {ProductStockUnitSummaryModel} from "../productStockUnitSummary.model";
import {ProductSummaryConverter} from "../../../../../api/entity/converter/productSummary.converter";
import {HttpModelConverter} from "../../../../../../core/converter/httpModel.converter";
import {DateConverter} from "../../../../../../common/converter/date.converter";
import {LovValueSummaryConverter} from "../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class ProductStockUnitSummaryConverter extends HttpModelConverter<ProductStockUnitSummaryModel> {

    constructor(private dateConverter: DateConverter,
                private lovValueSummaryConverter: LovValueSummaryConverter) {
        super();
    }

    protected createInstance(): ProductStockUnitSummaryModel {
        return new ProductStockUnitSummaryModel();
    }

    protected enrichObject(result: ProductStockUnitSummaryModel, src: ProductStockUnitSummaryModel) {
        result.exitDate = this.dateConverter.convert(src.exitDate);
        result.entryDate = this.dateConverter.convert(src.entryDate);
        result.color = this.lovValueSummaryConverter.convert(src.color)
    }

}
